import React from 'react';
import merge from 'classnames';

import { Props } from './types';

import styles from './RadioButton.module.scss';

export const RadioButton = ({ selected, className, ...rest }: Props) => (
  <div className={merge(styles.outer, className)} {...rest} data-testid="radio-button-wrapper">
    <div className={merge(styles.inner, { [styles.selected]: selected })} />
  </div>
);
